module.exports = __webpack_public_path__ + "static/media/iconMail.315af449.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconMail.svg
// module id = 998
// module chunks = 0